<template>
	<div>
		<detail-nav title="退款售后详情" @navigateBack="gpNavigateback"></detail-nav>

		<el-row :gutter="15">
			<el-col :span="12">
				<div id="layer1" class="gp-layer-body">
					<div class="gp-row gp-row-center">
						<div class="status-item">
							<div class="status-value">
								<!-- 退货退款 -->
								<template v-if="wx_status">退款中</template>
								<template v-else-if="baseinfo.status == 0">待品牌商处理</template>
								<template v-else-if="baseinfo.status == 2">退款成功</template>
								<template v-else-if="baseinfo.status == 3">已拒绝退款</template>
								<template v-else-if="baseinfo.status == 4">用户取消申请</template>
								<template v-else-if="baseinfo.status == 1">
									<template v-if="baseinfo.refund_mode == 1">
										{{baseinfo.express_code == '' ? '等待买家退回' : '待品牌商收货'}}
									</template>
									<template v-else-if="baseinfo.refund_mode == 2">
										待品牌商退款
									</template>
								</template>
							</div>
							<template v-if="wx_status">
								<div class="status-tip">退款金额将在2小时内原路返回</div>
							</template>
							<template v-else-if="0">
								<div class="status-tip">请尽快处理，申请将在08月20日自动同意</div>
							</template>
							<template v-else-if="0">
								<div class="status-tip">请尽快处理，申请将在08月20日自动退回</div>
							</template>
						</div>
					</div>

					<template v-if="baseinfo.status == 3">
						<div class="gp-row">
							<div class="gp-row-label"></div>
							<div class="gp-row-title">拒绝退款原因</div>
						</div>
						<div class="gp-section">
							<div class="red_text">{{baseinfo.remark}}</div>
						</div>
					</template>

					<div class="gp-row">
						<div class="gp-row-label"></div>
						<div class="gp-row-title">申请退款金额</div>
					</div>
					<div class="gp-section padding-top-15">
						<div class="gp-row">
							<div class="gp-label">申请商品退款</div>
							<div class="gp-label-value">¥{{baseinfo.apply_amount}}</div>
						</div>
						<template v-if="baseinfo.order_freight > 0">
							<div class="gp-row">
								<div class="gp-label">申请退运费</div>
								<div class="gp-label-value">¥{{baseinfo.freight_amount}}</div>
							</div>
						</template>
						<div class="gp-row">
							<div class="gp-label">总退款金额</div>
							<div class="gp-label-value red_price">¥{{baseinfo.total_amount}}</div>
						</div>
					</div>
					
					<template v-if="baseinfo.express_code">
						<div class="gp-row">
							<div class="gp-row-label"></div>
							<div class="gp-row-title">退货物流</div>
							<button class="gp-link-tip" @click="openfreight">查询详细物流</button>
						</div>
						<div class="gp-section padding-top-15">
							<div class="gp-row">
								<div class="gp-label">物流公司</div>
								<div class="gp-label-value">{{baseinfo.express_name}}</div>
							</div>
							<div class="gp-row"
							  v-clipboard:copy="baseinfo.express_code"
							  v-clipboard:success="onCopySuccess"
							  v-clipboard:error="onCopyError"
							>
								<div class="gp-label">物流单号</div>
								<div class="gp-label-value">{{baseinfo.express_code}}<span class="copy_txt margin-left-15">复制</span></div>
							</div>
						</div>
					</template>
					
					<el-form>
						<el-form-item>
							<div class="gp-row gp-row-center margin-top-70 padding-bottom-30">
								<template v-if="!wx_status">
									<template v-if="baseinfo.status == 0">
										<template v-if="baseinfo.refund_mode == 1">
											<el-button class="gp-btn_agree" type="primary" @click="agreeRefund">同意申请</el-button>
										</template>
										<template v-else-if="baseinfo.refund_mode == 2">
											<el-button class="gp-btn_agree" type="primary" @click="confirmRefund">同意并退款</el-button>
										</template>
										<el-button class="gp-btn_reject" type="primary" @click="rejectRefund">拒绝退款</el-button>
									</template>
									<template v-else-if="baseinfo.status == 1">
										<template v-if="baseinfo.refund_mode == 1">
											<el-button class="gp-btn_agree" type="primary" @click="confirmRefund">已收货退款</el-button>
										</template>
										<template v-else-if="baseinfo.refund_mode == 2">
											<el-button class="gp-btn_agree" type="primary" @click="confirmRefund">同意并退款</el-button>
										</template>
										<el-button class="gp-btn_reject" type="primary" @click="rejectRefund">拒绝退款</el-button>
									</template>
								</template>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</el-col>
			<el-col :span="12">
				<div id="layer2" class="gp-layer-body">
					<div class="gp-row padding-top-15">
						<div class="gp-row-label"></div>
						<div class="gp-row-title">退款信息</div>
					</div>
					<div class="gp-section padding-top-20 padding-bottom-15">
						<div class="product_item margin-bottom-15">
							<img class="product_cover" :src="baseinfo.sku_img">
							<div class="product_info">
								<div class="product_name max-line-2" style="-webkit-box-orient: vertical;" :title="baseinfo.product_name">{{baseinfo.product_name}}</div>
								<div class="product_sku_info margin-top-10">
									<div>{{baseinfo.sku_name}}</div>
									<div>x{{baseinfo.product_num}}</div>
								</div>
							</div>
						</div>
						
						<div class="gp-row">
							<div class="gp-label">退款类型</div>
							<div class="gp-label-value">{{baseinfo.refund_mode == 1 ? '退货退款' : '仅退款'}}</div>
						</div>
						
						<div class="gp-row" style="align-items: flex-start;">
							<div class="gp-label">退款原因</div>
							<div class="gp-label-value">{{baseinfo.refund_reason ? baseinfo.refund_reason : '买家未填写退款原因'}}</div>
						</div>
						
						<template v-if="baseinfo.imgsarr && baseinfo.imgsarr.length > 0">
							<div class="gp-row" style="align-items: flex-start;">
								<div class="gp-label">退款凭证</div>
								<div class="refund_reason_imgs">
									<img class="refund_reason_img" :src="imgs_item" v-for="(imgs_item, imgs_index) in baseinfo.imgsarr" :key="imgs_index" @click="openPreview(imgs_index)">
								</div>
							</div>
						</template>
					</div>
					
					<div class="gp-row padding-top-0">
						<div class="gp-row-label"></div>
						<div class="gp-row-title">基础信息</div>
					</div>
					<div class="gp-section padding-top-15">
						<div class="gp-row">
							<div class="gp-label">收货人信息</div>
							<div class="gp-label-value" v-if="baseinfo.user_address_info">{{baseinfo.user_address_info.name}}<span class="margin-left-15">{{baseinfo.user_address_info.phone}}</span></div>
						</div>
						
						<div class="gp-row"
						  v-clipboard:copy="baseinfo.order_sn"
						  v-clipboard:success="onCopySuccess"
						  v-clipboard:error="onCopyError"
						>
							<div class="gp-label">订单编号</div>
							<div class="gp-label-value" style="cursor: pointer;">{{baseinfo.order_sn}}<span class="copy_txt margin-left-15">复制</span></div>
						</div>
						
						<div class="gp-row" v-if="baseinfo.order_type == 8">
							<div class="gp-label">来自活动</div>
							<div class="gp-label-value" @click="goActivity(baseinfo.activity_id)" style="color: #409EFF;cursor: pointer; padding-right: 20px;">{{baseinfo.activity_name}} ></div>
						</div>
						
						<div class="gp-row">
							<div class="gp-label">商品实付</div>
							<div class="gp-label-value">￥{{baseinfo.product_amount}}</div>
						</div>
						
						<template v-if="baseinfo.order_freight > 0">
							<div class="gp-row">
								<div class="gp-label">订单运费</div>
								<div class="gp-label-value">￥{{baseinfo.order_freight}}</div>
							</div>
						</template>
						
						<div class="gp-row">
							<div class="gp-label">申请时间</div>
							<div class="gp-label-value">{{baseinfo.create_time}}</div>
						</div>
						
						<div class="gp-row">
							<div class="gp-label">支付时间</div>
							<div class="gp-label-value">{{baseinfo.pay_time}}</div>
						</div>
					</div>
					
				</div>
			</el-col>
		</el-row>
		
		<preview-imgs title="退款凭证" :show="showPreview" :imgs="imgs" :imgs_index="imgs_index" @close="closePreview" @change="changeImgsIndex"></preview-imgs>
		
		<dialog-agree :show="showDialogAgree" :apply_id="apply_id" :apply_amount="baseinfo.total_amount" @close="closeDialogAgree" @success="dialogAgreeSuccess"></dialog-agree>
		
		<dialog-confirm :show="showDialogConfirm" :apply_id="apply_id" :apply_mode="baseinfo.refund_mode" :apply_amount="baseinfo.total_amount" @close="closeDialogConfirm" @success="dialogConfirmSuccess"></dialog-confirm>
		
		<dialog-reject :show="showDialogReject" :apply_id="apply_id" @close="closeDialogReject" @success="dialogRejectSuccess"></dialog-reject>
	</div>
</template>

<script>
	import {
		getRefundDetail
	} from '../../api/order.js';
	import detailNav from '@/components/detail-nav.vue';
	import previewImgs from '@/components/preview-imgs.vue';
	import dialogAgree from '@/components/order/refund/dialog-agree.vue';
	import dialogConfirm from '@/components/order/refund/dialog-confirm.vue';
	import dialogReject from '@/components/order/refund/dialog-reject.vue';
	import Vue from 'vue';
	import VueClipboard from 'vue-clipboard2';
	Vue.use(VueClipboard);
	export default {
		data() {
			return {
				apply_id: 0,
				baseinfo: [], //基础信息
				wx_status: 0,
				showPreview: false, //预览图片
				imgs: [],
				imgs_index: 0,
				showDialogAgree: false, //显示同意申请弹框
				showDialogConfirm: false, //显示确认退款弹框
				showDialogReject: false, //显示拒绝退款弹框
			};
		},
		components: {
			detailNav,
			previewImgs,
			dialogAgree,
			dialogConfirm,
			dialogReject
		},
		mounted() {
			document.getElementsByClassName("father-main")[0].scrollTop = 0;
			
			var query = this.$route.query;
			if (query && query.apply_id) {
				this.apply_id = Number(query.apply_id);
				this.getDetail();
			}
			// 监听浏览器返回
			if (window.history && window.history.pushState) {
				// 向历史记录中插入了当前页
				history.pushState(null, null, document.URL);
				window.addEventListener('popstate', this.gpNavigateback, false);
			}
		},
		destroyed() {
			window.removeEventListener('popstate', this.gpNavigateback, false);
		},
		methods: {
			goActivity(id) {
				this.$router.push({
					path: '/promotion/interest-data',
					query: {
						event_id: id
					}
				});
			},
			gpNavigateback() {
				localStorage.setItem('keypage', this.list_page);
				this.$router.go(-1)
			},
			openfreight() {
				window.open("https://www.kuaidi100.com/", "_blank");
			},
			getDetail() {
				getRefundDetail({
					apply_id: this.apply_id,
				}).then(res => {
					if (res.code == 0) {
						this.baseinfo = res.data;
						this.wx_status = res.data.refund_status == 0 ? 1 : 0;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			// 预览图片
			openPreview(index) {
				this.imgs = this.baseinfo.imgsarr;
				this.imgs_index = index;
				this.showPreview = true;
			},
			// 同意退款申请
			agreeRefund() {
				this.showDialogAgree = true;
			},
			// 确认并退款
			confirmRefund() {
				this.showDialogConfirm = true;
			},
			// 拒绝退款
			rejectRefund() {
				this.showDialogReject = true;
			},
			
			/* 组件回调 */
			closePreview() {
				this.showPreview = false;
			},
			changeImgsIndex(res) {
				this.imgs_index = res.index;
			},
			
			onCopySuccess(res) {
				this.$message.success("内容已复制到剪切板");
			},
			onCopyError() {
				this.$message.error("复制失败");
			},
			
			closeDialogAgree() {
				this.showDialogAgree = false;
			},
			dialogAgreeSuccess() {
				this.showDialogAgree = false;
				this.getDetail();
			},
			
			closeDialogConfirm() {
				this.showDialogConfirm = false;
			},
			dialogConfirmSuccess() {
				this.showDialogConfirm = false;
				this.getDetail();
			},
			
			closeDialogReject() {
				this.showDialogReject = false;
			},
			dialogRejectSuccess() {
				this.showDialogReject = false;
				this.getDetail();
			}
		}
	};
</script>

<style scoped>
	.el-dialog__body {
		padding: 0;
	}
	
	.gp-layer-body {
		min-height: 640px;
		background: #FFFFFF;
		border-radius: 4px;
	}
	
	.gp-row {
		width: 100%;
		display: flex;
		align-items: center;
	}
	
	.gp-row-center {
		justify-content: center;
	}
	
	.gp-row-label {
		width: 3px;
		height: 25px;
		margin-right: 15px;
		background: #409EFF;
	}
	
	.gp-row-title {
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: bold;
		color: #333333;
		line-height: 30px;
	}
	
	.gp-section {
		padding: 30px 20px;
	}
	
	.gp-label {
		margin: 15px 0;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 14px;
	}
	
	#layer1 .gp-label {
		min-width: 124px;
	}
	
	#layer2 .gp-label {
		min-width: 96px;
		line-height: 20px;
	}
	
	.gp-label-value {
		margin: 15px 0;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 20px;
		white-space: pre-wrap;
		word-break: break-all;
	}
	
	.gp-btn_agree {
		letter-spacing: 1px;
		background: #0486FE;
	}
	
	.gp-btn_reject, .gp-btn_reject:focus, .gp-btn_reject:hover {
		letter-spacing: 1px;
		color: #606266;
		background: #FFFFFF;
		border: 1px solid #DCDFE6;
	}
	
	.gp-link-tip {
		margin: 0;
		padding: 0;
		background: unset;
		border: unset;
		margin-left: 15px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #409EFF;
		line-height: 22px;
	}
	
	.status-item {
		width: 438px;
		height: 113px;
		margin-top: 40px;
		margin-bottom: 30px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-image: url('../../assets/img/order/bg-orange.png');
		background-size: 100%;
		background-repeat: no-repeat;
	}
	
	.status-value {
		font-size: 21px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 29px;
	}
	
	.status-tip {
		margin-top: 10px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 20px;
	}

	.product_item {
		padding: 10px;
		display: flex;
		align-items: center;
		background: #F5F5F5;
		border-radius: 4px;
	}
	
	.product_cover {
		width: 80px;
		min-width: 80px;
		height: 80px;
		object-fit: cover;
		border-radius: 4px;
	}
	
	.product_info {
		width: 100%;
		margin-left: 5px;
	}
	
	.product_name {
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 20px;
	}
	
	.product_sku_info {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}
	
	.refund_reason_imgs {
		display: flex;
		flex-wrap: wrap;
		margin: 15px 0;
	}
	.refund_reason_img {
		width: 70px;
		height: 70px;
		object-fit: cover;
		margin: 0 10px 10px 0;
	}
	
	.red_text {
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #F56C6C;
		line-height: 22px;
		white-space: pre-wrap;
		word-break: break-all;
	}

	.red_price {
		margin: 0;
		font-size: 26px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #F56C6C;
		line-height: 40px;
	}
	
	.copy_txt {
		color: #409EFF;
	}

	.max-line-2 {
		display: -webkit-box;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		overflow: hidden;
		word-break: break-all;
	}
	.margin-top-70 {
		margin-top: 70px;
	}
	.margin-top-10 {
		margin-top: 10px;
	}
	.margin-left-15 {
		margin-left: 15px;
	}
	.margin-bottom-15 {
		margin-bottom: 15px;
	}
	.padding-top-0 {
		padding-top: 0;
	}
	.padding-top-15 {
		padding-top: 15px;
	}
	.padding-top-20 {
		padding-top: 20px;
	}
	.padding-bottom-15 {
		padding-bottom: 15px;
	}
	.padding-bottom-30 {
		padding-bottom: 30px;
	}
</style>
